import { Controller } from 'stimulus'

// A button that shows/hides the element named in its aria-controls, e.g.
//   <button data-controller="disclosure" data-action="disclosure#toggle"
//     aria-controls="listFilters" aria-expanded="false">
export default class extends Controller {
  toggle(event) {
    event.preventDefault()
    const panel = document.getElementById(this.element.getAttribute('aria-controls'))
    if (!panel) return

    panel.hidden = !panel.hidden
    this.element.setAttribute('aria-expanded', String(!panel.hidden))
    this.element.classList.toggle('active', !panel.hidden)
    if (!panel.hidden) panel.querySelector('input, select, button')?.focus()
  }
}
